"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
// This is defined as outlined here: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Will fomat the date for the LastModified cache header
 *
 * @export
 * @param {(Date | string)} date
 * @returns {string}
 */
function formatDateForLastModifiedCacheHeader(date) {
    if (!date) {
        return date;
    }
    if (typeof date === 'string') {
        date = new Date(date);
    }
    var daysOfTheWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var dayName = daysOfTheWeek[date.getUTCDay()];
    var day = date.getUTCDate();
    var month = months[date.getUTCMonth()];
    var year = date.getUTCFullYear();
    var hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    var second = date.getUTCSeconds();
    return dayName + ", " + _1.pad(day, 2, 0) + " " + month + " " + year + " " + _1.pad(hour, 2, 0) + ":" + _1.pad(minute, 2, 0) + ":" + _1.pad(second, 2, 0) + " GMT";
}
exports.formatDateForLastModifiedCacheHeader = formatDateForLastModifiedCacheHeader;
//# sourceMappingURL=cache.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/cache.js
// module id = 1472
// module chunks = 1